module.exports = __webpack_public_path__ + "static/media/Leopard Diary Logo Only.643c9e98.png";